






















































const MAX_SLIDER_IMAGE_COUNT = 5

interface Image {
  previewFile: {
    serviceUrl: string
  }
  uuid: string
}

import Vue, { PropOptions } from 'vue'

export default Vue.extend({
  props: {
    images: {
      type: Array,
      required: true
    } as PropOptions<Image[]>
  },
  data(): {
    selectedImageView: Image
    currentImageListIndex: number
    currentImage: string | null
  } {
    return {
      selectedImageView: this.images[0],
      currentImageListIndex: 0,
      currentImage: null
    }
  },
  computed: {
    isOverMaxImageCount(): boolean {
      return this.images.length > MAX_SLIDER_IMAGE_COUNT
    },
    splittedSkuImages() {
      const splittedSkuImages = []

      if (!this.isOverMaxImageCount) {
        splittedSkuImages.push(this.images)
        return splittedSkuImages
      }

      for (let i = 0; i < this.images.length; i += MAX_SLIDER_IMAGE_COUNT) {
        let splittedList = this.images.slice(i, i + MAX_SLIDER_IMAGE_COUNT)
        splittedSkuImages.push(splittedList)
      }

      return splittedSkuImages
    },
    currentImageView(): Image {
      return this.selectedImageView
    },
    isFirstImageList(): boolean {
      return this.currentImageListIndex === 0
    },
    isLastImageList(): boolean {
      return this.currentImageListIndex === this.splittedSkuImages.length - 1
    }
  },
  methods: {
    onClickSliderImage(id: string): void {
      this.selectedImageView = this.images.find(image => image.uuid === id)!
    },
    onClickControlSlider(command: string): number {
      return command === 'prev'
        ? (this.currentImageListIndex -= 1)
        : (this.currentImageListIndex += 1)
    }
  }
})
